import appGlobalScript from '/home/runner/work/twilight/twilight/packages/twilight-components/src/global/app.ts';
export const globalScripts = appGlobalScript;
